import admin from './admin.json';
import aiCopilot from './aiCopilot.json';
import assetGroups from './assetGroups.json';
import attackPaths from './attackPaths.json';
import auth from './auth.json';
import common from './common.json';
import dashboard from './dashboard.json';
import dataMap from './dataMap.json';
import dataSources from './dataSources.json';
import dataTypes from './dataTypes.json';
import endpoints from './endpoints.json';
import events from './events.json';
import integrations from './integrations.json';
import integrationTargets from './integrationTargets.json';
import learning from './learning.json';
import nav from './nav.json';
import policies from './policies.json';
import reports from './reports.json';
import sensors from './sensors.json';
import services from './services.json';
import storages from './storages.json';
import team from './team.json';

export default {
	admin,
	aiCopilot,
	assetGroups,
	attackPaths,
	auth,
	common,
	dashboard,
	dataMap,
	dataSources,
	dataTypes,
	endpoints,
	events,
	integrations,
	integrationTargets,
	learning,
	nav,
	policies,
	reports,
	sensors,
	services,
	storages,
	team,
};
